export default __webpack_public_path__ + "static/media/searchGray.62cb779d.svg";